/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyPinResponse
 */
export interface VerifyPinResponse {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyPinResponse
     */
    valid: boolean;
}

/**
 * Check if a given object implements the VerifyPinResponse interface.
 */
export function instanceOfVerifyPinResponse(value: object): value is VerifyPinResponse {
    if (!('valid' in value) || value['valid'] === undefined) return false;
    return true;
}

export function VerifyPinResponseFromJSON(json: any): VerifyPinResponse {
    return VerifyPinResponseFromJSONTyped(json, false);
}

export function VerifyPinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyPinResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'valid': json['valid'],
    };
}

export function VerifyPinResponseToJSON(json: any): VerifyPinResponse {
    return VerifyPinResponseToJSONTyped(json, false);
}

export function VerifyPinResponseToJSONTyped(value?: VerifyPinResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'valid': value['valid'],
    };
}

